import styled from 'styled-components';

export const SelectArea = styled.select`
  width: 100%;
  display: block;
  border: 1px solid #ececec;
  background-color: #f7f9fb;
  resize: none;
  border-radius: 10px;
  font-size: 20px;
  padding: 15px;
  margin: 15px 0 0 0;

  :focus {
    outline: none !important;
  }

  ::placeholder {
    font-size: 20px;
    color: #444444;
  }
`;
